import { render, staticRenderFns } from "./InvoicesCard.vue?vue&type=template&id=537ad88b&"
import script from "./InvoicesCard.vue?vue&type=script&lang=js&"
export * from "./InvoicesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports